import React, { memo, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Grid, message } from 'antd';
import { ExportOutlined } from '@ant-design/icons';
import moment from 'moment';
import { RESTExportPost } from 'utils/RESTApi';
import {
  getCurrentOrganization,
  getCurrnetUserData,
} from 'store/slices/loginSlice';
import { GetFileFromS3 } from 'utils/commonMethods';
import { dateTimeFormat } from 'utils/Constants';
import { getDefaultBatchID } from 'store/slices/compareSlice';
import { fetchOrganizationStages } from 'utils/CommonFunctions';
const ExportItemsButton = ({
  orgId,
  departmentFilter,
  stageFilterLevel,
  timeRange,
  customRange,
  submittedByOwner,
  rankValue,
}) => {
  const currnetOrg = useSelector(getCurrentOrganization);
  const loginUsrOrg = useSelector(getCurrnetUserData);
  const userId = currnetOrg?.adminID || loginUsrOrg?.id;
  const userEmail = currnetOrg?.Admin?.email || loginUsrOrg?.email;
  const adminUserName =
    currnetOrg?.Admin?.firstName + ' ' + currnetOrg?.Admin?.lastName;
  const superAdminName = loginUsrOrg?.firstName + ' ' + loginUsrOrg?.lastName;
  const userName = currnetOrg ? adminUserName : superAdminName;
  let priorityDefaultBatchID =
    currnetOrg?.defaultPrioirtybatch?.id ||
    loginUsrOrg?.Organization?.organizationDefaultPrioirtybatchId;
  const fetchDefaultBatchID = useSelector(getDefaultBatchID);
  const defaultPriorityBatchID = fetchDefaultBatchID
    ? fetchDefaultBatchID
    : priorityDefaultBatchID;
  const [loading, setLoading] = useState(false);
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const exportRankingsFlag = (array, value) => {
    return array.includes(value);
  };
  const [allStages, setAllStages] = useState([]);
  const getStageName = async () => {
    try {
      const sortedStages = await fetchOrganizationStages(orgId);
      setAllStages(sortedStages);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    getStageName();
    // eslint-disable-next-line
  }, []);
  const getRankingsByDate = {
    today: [
      moment().startOf('day').format(dateTimeFormat),
      moment().format(dateTimeFormat),
    ],
    last7days: [
      moment().subtract(7, 'd').startOf('day').format(dateTimeFormat),
      moment().format(dateTimeFormat),
    ],
    lastWeek: [
      moment().subtract(1, 'weeks').startOf('week').format(dateTimeFormat),
      moment().subtract(1, 'weeks').endOf('week').format(dateTimeFormat),
    ],
    thisMonth: [
      moment().startOf('month').format(dateTimeFormat),
      moment().format(dateTimeFormat),
    ],
    lastMonth: [
      moment().subtract(1, 'months').startOf('month').format(dateTimeFormat),
      moment().subtract(1, 'months').endOf('month').format(dateTimeFormat),
    ],
    customRange: customRange
      ? [
          customRange[0].format(dateTimeFormat),
          customRange[1].format(dateTimeFormat),
        ]
      : [],
  };
  const getRanks = () => {
    if (rankValue.length) {
      return {
        Default: exportRankingsFlag(rankValue, 'Default Ranks'),
        Assigned: exportRankingsFlag(rankValue, 'Assigned Ranks'),
      };
    }
    return {};
  };
  const getStage = () => {
    const selectedStages = stageFilterLevel;
    if (selectedStages.length) {
      const result = {};
      allStages.forEach((item) => {
        const id = item?.id;
        const isSelected = selectedStages.includes(id);
        result[id] = isSelected;
      });
      return result;
    }
    return {};
  };
  const exportRankingsOnly = async () => {
    setLoading(true);
    try {
      let variables = {
        id: orgId,
        priorityBatchID: defaultPriorityBatchID,
        exportData: 'Rankings',
        exportMedium: 'email',
        email: userEmail,
        name: userName,
        filters: {
          byMe: submittedByOwner ? userId : '',
          Ranks: getRanks(),
          Stage: getStage(),
          Department: departmentFilter,
          Created: getRankingsByDate[timeRange]
            ? getRankingsByDate[timeRange]
            : [],
        },
      };
      const exportResponse = await RESTExportPost(variables);
      let fileKey = exportResponse?.body?.fileKeys?.[0]?.split('/')[1];
      let downLoadFile;
      downLoadFile = await GetFileFromS3(fileKey);
      setLoading(false);
      window.open(downLoadFile);
      message.success('File exported successfully');
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  return (
    <>
      <Button
        className="ml-10 h-35 filter-btn border-color typography-color fw-400"
        onClick={exportRankingsOnly}
        loading={loading}
      >
        <ExportOutlined className="export-icon" /> {screens.xs ? '' : 'Export'}
      </Button>

    </>
  );
};
export default memo(ExportItemsButton);

